import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { fmtErr } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", business_name: "", contact_name: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created. Awaiting approval.");
      nav("/portal");
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const input = "w-full bg-white border border-[#E5D8C1] px-4 py-3 focus:outline-none focus:border-[#D32F2F]";
  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-root">
      <h1 className="font-heading text-5xl uppercase tracking-wide">Create account</h1>
      <p className="mt-3 text-[#5C5A56]">Sign up to track your orders and get portal access once approved.</p>
      <form onSubmit={submit} className="mt-8 bg-[#FDF4E3] border border-[#E5D8C1] p-8 space-y-4">
        <label className="block"><span className="text-xs uppercase tracking-widest">Business name</span>
          <input required value={form.business_name} onChange={(e) => setForm({...form, business_name: e.target.value})} className={input + " mt-2"} data-testid="register-business" />
        </label>
        <label className="block"><span className="text-xs uppercase tracking-widest">Your name</span>
          <input required value={form.contact_name} onChange={(e) => setForm({...form, contact_name: e.target.value})} className={input + " mt-2"} data-testid="register-name" />
        </label>
        <label className="block"><span className="text-xs uppercase tracking-widest">Email</span>
          <input required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className={input + " mt-2"} data-testid="register-email" />
        </label>
        <label className="block"><span className="text-xs uppercase tracking-widest">Phone</span>
          <input value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} className={input + " mt-2"} data-testid="register-phone" />
        </label>
        <label className="block"><span className="text-xs uppercase tracking-widest">Password (min 6)</span>
          <input required type="password" minLength={6} value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className={input + " mt-2"} data-testid="register-password" />
        </label>
        <button type="submit" disabled={loading} className="w-full bg-[#D32F2F] text-white hover:bg-[#B71C1C] py-4 uppercase tracking-widest font-heading disabled:opacity-60 flex items-center justify-center gap-2" data-testid="register-submit">
          {loading && <Loader2 className="animate-spin" size={18} />} Create account
        </button>
        <div className="text-center text-sm text-[#5C5A56]">Have an account? <Link to="/login" className="text-[#D32F2F] font-semibold">Sign in</Link></div>
      </form>
    </div>
  );
}
